<template>
    <div class="page-layout" style="overflow-y: auto;">
        <div class="d-flex flex-wrap justify-content-between">
            <div class="d-flex align-items-center mb-2" style="gap:1rem">
                <div class="dropdown">
                    <a class="btn ticket-list-button btn-wide" href="#" role="button" id="dropdownMenuLink"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="background: none;">
                        <div class="d-flex justify-content-between">
                            <div>
                                <span v-if="active_tab == 'overall'" class="ticketlist-dropdown">Overall
                                    Tickets({{total_tickets}})</span>
                                <span v-if="active_tab == 'open'" class="ticketlist-dropdown">Open
                                    Tickets({{open}})</span>
                                <span v-if="active_tab == 'unassigned'" class="ticketlist-dropdown">Unassigned
                                    Tickets({{unassigned}})</span>
                                <span v-if="active_tab == 'inprogress'" class="ticketlist-dropdown">InProgress
                                    Tickets({{inprogress}})</span>
                                <span v-if="active_tab == 'fixed'" class="ticketlist-dropdown"> Fixed
                                    Tickets({{fixed}})</span>
                                <span v-if="active_tab == 'reopened'" class="ticketlist-dropdown">Reopened
                                    Tickets({{reopened}})</span>
                                <span v-if="active_tab == 'discard'" class="ticketlist-dropdown">Discarded Tickets({{
                                    discard }})</span>
                                <span v-if="active_tab == 'closed'" class="ticketlist-dropdown">Closed
                                    Tickets({{closed}})</span>
                                <span v-if="active_tab == 'review'" class="ticketlist-dropdown">Review
                                    Tickets({{review}})</span>
                            </div>
                            <div class="mr-3">
                                <i class="icon-chevron-down org-icon-rotate-transition org-icon-down fs-22"
                                    style="color: #00448b;border: 1px solid #00448b;border-radius: 4px;"></i>
                            </div>
                        </div>
                    </a>
                    <div class="dropdown-menu dropDownBox" aria-labelledby="dropdownMenuLink">
                        <a class="dropdown-item" :class="{'new-blue':active_tab == 'overall'}"
                            v-on:click="confirmSelectView('overall',true)">
                            <div class="d-flex justify-content-between">
                                <div class="fw-500">Overall </div>
                                <div class="total-count fw-400">({{total_tickets}})</div>
                            </div>
                        </a>
                        <a class="dropdown-item" :class="{'new-blue':active_tab == 'open'}"
                            v-on:click="confirmSelectView('open',true)">
                            <div class="d-flex justify-content-between">
                                <div class="fw-500">Opened </div>
                                <div class="total-count fw-400">({{open}})</div>
                            </div>
                        </a>
                        <a class="dropdown-item" :class="{'new-blue':active_tab == 'inprogress'}"
                            v-on:click="confirmSelectView('inprogress',true)">
                            <div class="d-flex justify-content-between">
                                <div class="fw-500">InProgress </div>
                                <div class="total-count fw-400">({{inprogress}})</div>
                            </div>
                        </a>
                        <a class="dropdown-item" :class="{'new-blue':active_tab == 'fixed'}"
                            v-on:click="confirmSelectView('fixed',true)">
                            <div class="d-flex justify-content-between">
                                <div class="fw-500">Fixed </div>
                                <div class="total-count fw-400">({{fixed}})</div>
                            </div>
                        </a>
                        <a class="dropdown-item" :class="{'new-blue':active_tab == 'reopened'}"
                            v-on:click="confirmSelectView('reopened',true)">
                            <div class="d-flex justify-content-between">
                                <div class="fw-500">Re-Opened </div>
                                <div class="total-count fw-400">({{reopened}})</div>
                            </div>
                        </a>
                        <a class="dropdown-item" :class="{'new-blue':active_tab == 'closed'}"
                            v-on:click="confirmSelectView('closed',true)">
                            <div class="d-flex justify-content-between">
                                <div class="fw-500">Closed </div>
                                <div class="total-count fw-400">({{closed}})</div>
                            </div>
                        </a>
                        <a class="dropdown-item" :class="{'new-blue':active_tab == 'review'}"
                            v-on:click="confirmSelectView('review',true)">
                            <div class="d-flex justify-content-between">
                                <div class="fw-500">Review </div>
                                <div class="total-count fw-400">({{review}})</div>
                            </div>
                        </a>
                        <a class="dropdown-item" :class="{'new-blue':active_tab == 'discard'}"
                            v-on:click="confirmSelectView('discard',true)">
                            <div class="d-flex justify-content-between">
                                <div class="fw-500">Discard </div>
                                <div class="total-count fw-400">({{discard}})</div>
                            </div>
                        </a>
                        <a class="dropdown-item" :class="{'new-blue':active_tab == 'unassigned'}"
                            v-on:click="confirmSelectView('unassigned',true)">
                            <div class="d-flex justify-content-between">
                                <div class="fw-500">Unassigned </div>
                                <div class="total-count fw-400">({{unassigned}})</div>
                            </div>
                        </a>
                    </div>
                </div>
                <!-- <div class="hor-line mr-3" style="width: 2px !important;height: 30px !important;background-color: #1b57ad;"></div> -->
            </div>
            <div class="mb-2">
                <button v-if="!show_review_tickets" class="btn btn-secondary-new btn-smm mr-2" @click="showFilters()">
                    <!-- <i class="icon icon-filter-outline fs-18 text-white"></i> -->
                    <img src="/static/images/new-theme2024/newfilter-icon.png" width="28px" alt="filter">
                    <span class="text-white ml-1 hidden-sm-down fs-14 fw-500">Filter</span>
                </button>
                <!-- <button class="btn btn-create btn-smm " style="color:#fff !important;height:35px !important"
                    @click="createTickets">
                    <i class="icon icon-plus-circle text-white fs-16"
                        style="color: #388e3c !important; position: relative; top: -1px;"></i>
                    <span class="ml-1 hidden-sm-down fs-14 fw-500" style="color: #038b62;"> New Ticket </span>
                </button> -->
                <button class="btn btn-create btn-smm" @click="createTickets">
                    <i class="icon icon-plus-circle create-icon fs-20"></i>
                    <span class="ml-1 hidden-sm-down fs-14 fw-500" style="color: #038b62;"> New Ticket </span>
                </button>

            </div>
        </div>
        <div class="pb-2 pl-2 pr-3 position-content-main" style="min-height:fit-content;">
            <div class="d-flex flex-wrap justify-content-between">
                <div class="breadcrumbnewtheme px-2 mt-3">
                    <div class="pre gap-0p5 fw-500">
                        Ticket List View
                    </div>
                    <span style="color:#b2bec3">/</span>
                    <span class="pre gap-0p5 fw-500 text-capitalize">
                        {{ $route.query.hasOwnProperty("view_ticket") ? $route.query.view_ticket : 'Overall' }}
                    </span>
                </div>
                <div class="mt-3 mb-2 align-items-center">
                    <button @click="firstPage()" :disabled="pagination.skip == 0" class="pointer mr-2 pagination-list">
                        <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                            <!-- <i class="icon-chevron-double-left text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left.svg" style=" z-index: 10">
                        </el-tooltip>
                    </button>
                    <button @click="previousPage()" :disabled="pagination.skip == 0" class="pagination-list-single pointer">
                        <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                            <!-- <i class="icon icon-chevron-left text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left-single.svg" style=" z-index: 10">
                        </el-tooltip>
                    </button>
                    <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} -
                        {{pagination.total>pagination.skip+pagination.limit?pagination.skip+pagination.limit:pagination.total}}
                        of {{pagination.total}}</span>
                    <button @click="nextPage()"
                        :disabled="pagination.skip_temp >= pagination.total || pagination.temp_total == pagination.total"
                        class="pagination-list-single pointer mr-2">
                        <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                            <!-- <i class="icon icon-chevron-right text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right-single.svg" style=" z-index: 10">

                        </el-tooltip>
                    </button>
                    <button @click="lastPage()" class="pointer pagination-list"
                        :disabled="pagination.temp_total == pagination.total">
                        <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                            <!-- <i class="icon-chevron-double-right text-black"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right.svg" style=" z-index: 10">

                        </el-tooltip>
                    </button>
                </div>
        </div>
        <div class="vendor-list height-fit-content mt-1" style="background-color: #f0ddb7 !important;">

            <!-- sort by -->
            <!-- <div class="d-flex flex-wrap justify-content-between mb-1 mt-2" v-if="tabs.length > 0" style="gap:1rem">
                <div class="w-100 inner-line-hr-tag ml-2 mr-1"></div>
                <div class="d-flex align-items-center px-2" style="gap:.5rem;flex-wrap: wrap">
                    <span class="fw-600 whitespace-nowrap">Sort by:</span>
                    <div class="d-flex align-items-center justify-content-between width-fit-content pointer tags-custom mr-3"
                        v-for="(f, f_index) in tabs" :key="f_index"
                        :class="{ 'selected-tag': f_index === selectedTicketIndex }" v-if="f_index <= 4">
                        <span class="ml-2 fw-500 text-nowrap text-black fs-12" @click="selectTicket(f, f_index)"
                            :class="{ 'selected-tag': f_index === selectedTicketIndex }"
                            >Ticket #{{ f.ticket_number }}</span>
                        <el-tooltip class="item" effect="dark" content="Close" placement="top">
                            <i class="icon icon-close text-black fs-18 pointer"
                                :class="{ 'selected-tag': f_index === selectedTicketIndex }"
                                @click="removeTicketTab(f_index)"></i>
                        </el-tooltip>
                    </div>
                </div>
                <div class="w-100 inner-line-hr-tag ml-2 mr-1"></div>
            </div> -->
        <div class="p-0">
            <div v-if="ajax_call_in_progress" class="text-center w-100 d-flex justify-content-center">
                <!-- <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/> -->
                <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
            </div>
            <div v-else>
                <!-- <div class="d-flex flex-wrap justify-content-end mb-1" v-if="show_review_tickets">
                    <div class="mt-1 d-flex align-items-center" style="gap:.5rem">
                        <span class="" style="color: #363636;font-weight: 700;">Status:</span>
                        <button v-if="showDetails.part_review_status" style="text-transform: capitalize;"
                            class="btn btn-smm btn-default text-white btn-success-border-radius" :class="{
                                            'btn-reopen-newtheme':showDetails.part_review_status == 'Sent For Approval' || showDetails.part_review_status == 'Review',
                                            'btn-rejected':showDetails.part_review_status == 'Reject', 
                                            'btn-schedule':showDetails.part_review_status == 'Scheduled',
                                            'btn-approved':showDetails.part_review_status == 'Approved',
                                            'rejected-btn':showDetails.part_review_status == 'Rejected'}">
                            {{showDetails.part_review_status}}
                        </button>
                    </div>
                </div> -->
                <div class="row" style="background: #f0ddb7;">
                    <div class="col-lg-4 col-md-4 col-sm-6 left-list" style="margin-right: -10px; ">
                        <review-tickets :pagination="pagination" :getSkipCount="getSkipCount" :allTickets="allTickets"
                            v-if="show_review_tickets" :list_id_index="list_id_index"
                            @getReviewTicketDetails="getReviewTicketDetails"
                            :ajaxCallInProgress="ajaxCallInProgress"></review-tickets>
                        <overall :getSkipCount="getSkipCount" :allTickets="allTickets"
                            :ajaxCallInProgress="ajaxCallInProgress" @setSelectedListIndex="setSelectedListIndex"
                            @hideFilters="hideFilters" @updateTabsForList="updateTabsForList"
                            :display_filters="display_filters" :list_id_index="list_id_index"
                            :showfilterData="showfilterData" :hide_filters="hide_filters"
                            v-else-if="show_ticket_details" :active_tab="active_tab" :showDetails="showDetails"
                            @appliedFilter="appliedFilter" @updateOverAllCount="getTicketCountAPI()">
                        </overall>
                        <ArchieveTickets v-else />
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-6 view-box scroll-new br-5"
                        style="overflow-y: auto !important;height: max-content !important; background: white;">
                        <ticket-details v-if="show_ticket_details" class="scroll-news" :showDetails="showDetails" 
                            :watch_status="watch_status" :list_loader="ajaxCallInProgress"
                            @updateStatus="updateStatus" @updateListForArchival="updateListForArchival"
                            :is_ticket_not_found="is_ticket_not_found" :pagination="pagination">
                        </ticket-details>
                        <archive-ticket-details v-else-if="show_archive_tickets"></archive-ticket-details>
                        <ApproveByTicketDetails v-else-if="show_review_tickets" :showDetails="showDetails"
                            @previewImage="previewImage" @callTicketList="callTicketList" />
                    </div>
                </div>
            </div>
        </div>
        <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
        <file-viewer v-if="show_file_viewer" :fileType="doc_file_url_type" :fileUrl="file_url_for_view" :file_name_for_view='file_name_for_view' :file_type_for_view="file_type_for_view" @hideFileViewer="hideFileViewer"></file-viewer>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
    </div>
    <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
    <file-viewer v-if="show_file_viewer" :fileType="doc_file_url_type" :fileUrl="file_url_for_view"
        :file_name_for_view='file_name_for_view' :file_type_for_view="file_type_for_view"
        @hideFileViewer="hideFileViewer"></file-viewer>
    <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
    <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
var mime = require('mime-types')
import { EventBus } from '../eventBus/nav-bar-event.js';
import ticket from '../mixins/ticket';
const Overall = () => import("../Tickets/Overall.vue");
const ArchieveTickets =() => import('../ArchieveTickets/ListView.vue')
const ReviewTickets = () => import("./ReviewTickets.vue")
const TicketDetails = () => import("../Tickets/TicketDetails.vue");
const ArchiveTicketDetails = () => import('../ArchieveTickets/DetailsView.vue')
const ApproveByTicketDetails = () => import("../Tickets/ApproveByTicketDetails.vue")
const Tab = () => import("./Tab.vue");
const FilterData = () => import('./FilterData')
import {SweetModal} from 'sweet-modal-vue';
import dashboard from '../mixins/dashboard.js';
const Preview = () => import('../Preview.vue')
const FileViewer = () => import('../FileViewer.vue')
export default {
    mixins:[dashboard, ticket],
    components:{
            Overall,
            FileViewer,
            Preview,
            TicketDetails,
            ArchiveTicketDetails,
            SweetModal,
            Tab,
            ReviewTickets,
            FilterData,
            ApproveByTicketDetails,
            ArchieveTickets
     },
    data(){
        return{
            is_ticket_not_found: false,
            preview_file: '',
            preview_visible: false,
            show_file_viewer: false,
            doc_file_url_type: '',
            file_url_for_view: '',
            file_name_for_view: '',
            file_type_for_view: '',
            active_tab: 'overall',
            ticketStatus:'',
            hideOverall:true,
            showChange: false,
            ticket_id: '',
            active_ticket:'Email',
            closed:0,
            fixed:0,
            open:0,
            inprogress:0,
            reopened:0,
            discard: 0,
            review: 0,
            total_tickets:0,
            allTickets: [],
            unassigned:0,
            statusTab:[],
            ajax_call_in_progress:false,
            temp_dashb_filter: null,
            show_review_tickets: false,
            show_ticket_details: true,
            show_archive_tickets: false,
            display_filters: false,
            hide_filters: false,
            search_key: '',
            watch_status: '',
            pagination:{
                skip:0,
                limit:10,
                total:0,
                temp_total:0,
                skip_temp: 0,
            },
            showfilterData:{
                created_templates: [],
                approvers: [],
                assigned_to:[],
                branch:[],
                company_name:[],
                created_date:[],
                department:[],
                last_modified_date:[],
                priority:[],
                product:[],
                status:[],
                ticket_number:[],
                template:[],
                behalf_selected:[],
                behalf_of_whom:'customer',
                assign_to_whom:'person',
                ticket_type:'',
                created_tags: [],
                saveFilter: null
            },
            filterData:{
                created_templates: [],
                assigned_to:[],
                branch:[],
                approvers: [],
                company_name:[],
                created_date:[],
                department:[],
                last_modified_date:[],
                priority:[],
                product:[],
                status:[],
                ticket_number:[],
                template:[],
                behalf_selected:[],
                behalf_of_whom:'customer',
                assign_to_whom:'person',
                ticket_type:'',
                created_tags: [],
            },
            dd_status: '',
            showDetails: '',
            tabs: [],
            selectedTicketIndex: 0,
            ticket_details: '',
            general_details: '',
            passed_key: {
                key: 'ticket_number',
                value: -1
            },
            ajaxCallInProgress: false,
            list_id_index: 0,
        }
    },
    methods:{
        hidePreview(){
            this.preview_visible = false
            EventBus.$emit('ZindexChangeEnd')
        },
        previewImage(file) {
            EventBus.$emit('ZindexChangeStart')
            let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
            file['content_type'] = content_type;
            this.preview_file = file;
            if(this.preview_file.name.endsWith('.doc') || this.preview_file.name.endsWith('.docx') || this.preview_file.name.endsWith('.pdf') 
                || this.preview_file.name.endsWith('.ppt') || this.preview_file.name.endsWith('.pptx') || this.preview_file.name.endsWith('.txt') 
                || this.preview_file.name.endsWith('.txt') || this.preview_file.name.endsWith('.xls') || this.preview_file.name.endsWith('.xlsx') 
                || this.preview_file.name.endsWith('.xlsx') || this.preview_file.name.endsWith('.bmp') || this.preview_file.name.endsWith('.jpeg') 
                || this.preview_file.name.endsWith('.png') || this.preview_file.name.endsWith('.svg') || this.preview_file.name.endsWith('.avi') 
                || this.preview_file.name.endsWith('.mp3') || this.preview_file.name.endsWith('.mpeg') || this.preview_file.name.endsWith('.mp4')
                || this.preview_file.name.endsWith('.jpg') 
            ){
                if (/\.(docx|xlsx|pptx|doc|xls|ppt|pdf|svg|txt)$/i.test(file.name)) {
                    this.viewFile(this.preview_file)
                } else {
                    this.preview_visible = true;
                }
            } else {
                this.$toasted.global.error("File Format Not Supported")
            }
        },
        viewFile(file) {
            this.file_url_for_view = file.url || "";
            this.file_name_for_view = file.name;
            this.show_file_viewer = true;
            this.file_type_for_view = file.content_type
        },
        hideFileViewer() {
            this.show_file_viewer = false;
        },
        showFilters(){
            EventBus.$emit('ZindexChangeStart')
            if(this.display_filters){
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        hideFilters(){
            this.hide_filters = true
            this.display_filters = false
            setTimeout(() => {
                this.hide_filters = false
            }, 500);
        },
        updateStatus(status){
            console.log(status)
            this.allTickets[this.list_id_index].status = status
            this.showDetails = this.allTickets[this.list_id_index]
            this.watch_status = status
            // this.getAllTicketAPI()
        },
        getReviewTicketDetails(index){
            this.list_id_index = index
            this.showDetails = this.allTickets[this.list_id_index]
            this.watch_status = status
        },
        updateListForArchival(){
            this.list_id_index = 0
            this.getAllTicketAPI()
        },
        callTicketList(){
            this.getAllTicketAPI()
        },
        appliedFilter(data){
            this.filterData = {
                created_templates: data.filterData.created_templates,
                created_tags: data.filterData.created_tags,
                assigned_to:data.filterData.assigned_to,
                approvers: data.filterData.approvers,
                branch:data.filterData.branch,
                company_name:data.filterData.company_name,
                created_date:data.filterData.created_date,
                department:data.filterData.department,
                last_modified_date:data.filterData.last_modified_date,
                priority:data.filterData.priority,
                product:data.filterData.product,
                status:data.filterData.status,
                ticket_number:data.filterData.ticket_number,
                template:data.filterData.template,
                assign_to_whom:data.filterData.assign_to_whom,
                behalf_of_whom:data.filterData.behalf_of_whom,
                behalf_selected:data.filterData.behalf_selected,
                ticket_type:data.filterData.ticket_type
            }
            this.showfilterData = {
                saveFilter: data.showfilterData.saveFilter,
                created_templates: data.showfilterData.created_templates,
                created_tags: data.showfilterData.created_tags,
                assigned_to:data.showfilterData.assigned_to,
                approvers: data.showfilterData.approvers,
                branch:data.showfilterData.branch,
                company_name:data.showfilterData.company_name,
                created_date:data.showfilterData.created_date,
                department:data.showfilterData.department,
                last_modified_date:data.showfilterData.last_modified_date,
                priority:data.showfilterData.priority,
                product:data.showfilterData.product,
                status:data.showfilterData.status,
                ticket_number:data.showfilterData.ticket_number,
                template:data.showfilterData.template,
                assign_to_whom:data.showfilterData.assign_to_whom,
                behalf_of_whom:data.showfilterData.behalf_of_whom,
                behalf_selected:data.showfilterData.behalf_selected,
                ticket_type:data.filterData.ticket_type
            }
            this.getAllTicketAPI()
        },
        setSelectedListIndex(index){
            this.list_id_index = index
            this.showDetails = this.allTickets[this.list_id_index]
            this.watch_status = status
            // this.getAllTicketAPI()
        },
        updateTabsForList(){
            if(localStorage.getItem('listData')){
                this.tabs = JSON.parse(localStorage.getItem('listData'))
            }
        },
        removeTicketTab(index){
            if(localStorage.getItem('listData')){
                this.tabs = JSON.parse(localStorage.getItem('listData'))
                this.tabs.splice(index, 1)
                if(this.tabs.length == 0){
                    this.list_id_index = 0
                    this.showDetails = this.allTickets[this.list_id_index]
                    this.watch_status = status
                    this.showDetails = this.allTickets[0]
                } else {
                    if(index - 1 < 0){
                        this.showDetails = this.tabs[index || 0]
                    } else {
                        this.showDetails = this.tabs[index-1 || 0]
                    }
                }
                localStorage.setItem('listData', JSON.stringify(this.tabs))
            }
        },
        firstPage(){
            this.pagination.temp_total = 0
            this.pagination.skip = 0
            this.pagination.limit = 10
            this.pagination.skip_temp = 0
            this.list_id_index = 0
            this.getAllTicketAPI()
        },
        lastPage(){
            this.pagination.skip_temp = 0
            this.pagination.skip = 0
            this.pagination.temp_total = this.pagination.total
            let no_of_pages = Math.ceil(this.pagination.total/this.pagination.limit)
            this.pagination.skip_temp = (no_of_pages * this.pagination.limit) - this.pagination.limit
            if (this.pagination.skip_temp >= this.pagination.total) {
                return;
            }
            this.pagination.skip = this.pagination.skip_temp
            this.list_id_index = 0
            this.getAllTicketAPI()
        },
        selectTicket(ticket, index) {
        this.selectedTicketIndex = index;
        this.viewTicketFromTab(ticket);
    },
        viewTicketFromTab(ticket){
            this.showDetails = ticket
        },
        nextPage() {
            this.pagination.skip_temp = this.pagination.skip + this.pagination.limit > this.pagination.total ? this.pagination.total : this.pagination.skip + this.pagination.limit;
            this.pagination.temp_total = this.pagination.skip_temp
            if (this.pagination.skip_temp >= this.pagination.total) {
                return;
            }
            this.pagination.skip = this.pagination.skip_temp;
            this.list_id_index = 0
            this.getAllTicketAPI()
        },
        previousPage() {
            this.pagination.temp_total = 0
            this.pagination.skip_temp = 0
            if (this.pagination.skip == 0) {
                return;
            }
            this.pagination.skip = this.pagination.skip - this.pagination.limit <= 0 ? 0 : this.pagination.skip - this.pagination.limit;
            this.list_id_index = 0
            this.getAllTicketAPI()
        },
        getTotal(){
            EventBus.$on('total', (data) => {
                this.total = data
            })
        },
        createTickets() {
            let ticket ={
                ticket_id:'',
                ticket_number:''
            }
            localStorage.setItem("parentTicketDetails", JSON.stringify(ticket))
            this.$router.push({ name: "TicketsCreate" });
        },
        confirmSelectView(obj){
            this.filterData.status = []
            this.showfilterData.status = []
            let newData = {
                filterData: this.filterData,
                showfilterData: this.showfilterData
            }
            localStorage.setItem("StoreFilterData", JSON.stringify(newData))
            this.selectView(obj)
        },
        selectView(obj){
            try{
                this.active_tab = obj;
                if(localStorage.getItem('storeQueryTicketType')){
                    this.show_ticket_details = true
                    this.show_review_tickets = false
                    this.show_archive_tickets = false
                    let status = JSON.parse(localStorage.getItem('storeQueryTicketType'))
                    if(status.view_ticket == 'opened') {
                        this.active_tab = 'open'
                        this.dd_status = "open"
                    } else if(status.view_ticket == 'overall'){
                        this.dd_status = ""
                    } else {
                        this.active_tab = status.view_ticket
                        this.dd_status = status.view_ticket
                    }
                    this.$router.push(`/ticketdetails?view_ticket=${status.view_ticket}`);
                    localStorage.removeItem('storeQueryTicketType')
                } else {
                    switch(obj){
                        case 'overall':
                            this.show_ticket_details = true
                            this.show_review_tickets = false
                            this.show_archive_tickets = false
                            this.dd_status = ""
                            this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'overall'} }).catch((err) => {});
                            break;
                        case 'open':
                            this.show_ticket_details = true
                            this.show_review_tickets = false
                            this.show_archive_tickets = false
                            this.dd_status = "open"
                            this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'opened'} }).catch((err) => {});
                            break;
                        case 'inprogress':
                            this.show_ticket_details = true
                            this.show_review_tickets = false
                            this.show_archive_tickets = false
                            this.dd_status = "inprogress"
                            this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'inprogress'} }).catch((err) => {});
                            break;
                        case 'fixed':
                            this.show_ticket_details = true
                            this.show_review_tickets = false
                            this.show_archive_tickets = false
                            this.dd_status = "fixed"
                            this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'fixed'} }).catch((err) => {});
                            break;
                        case 'closed':
                            this.show_ticket_details = true
                            this.show_review_tickets = false
                            this.show_archive_tickets = false
                            this.dd_status = "closed"
                            this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'closed'} }).catch((err) => {});
                            break;
                        case 'reopened':
                            this.show_ticket_details = true
                            this.show_review_tickets = false
                            this.show_archive_tickets = false
                            this.dd_status = "reopened"
                            this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'reopened'} }).catch((err) => {});
                            break;
                        case 'unassigned':
                            this.show_ticket_details = true
                            this.show_review_tickets = false
                            this.show_archive_tickets = false
                            this.dd_status = "unassigned"
                            this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'unassigned'} }).catch((err) => {});
                            break;
                        case 'review':
                            this.show_ticket_details = false
                            this.show_review_tickets = true
                            this.show_archive_tickets = false
                            this.dd_status = ""
                            this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'review'} }).catch((err) => {});
                            break;
                        case 'discard':
                            this.show_ticket_details = true
                            this.show_review_tickets = false
                            this.show_archive_tickets = false
                            this.dd_status = "discard"
                            this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'discard'} }).catch((err) => {});
                            break;
                    };
                }
                if(localStorage.getItem('storeDashboardFilter')){
                    this.temp_dashb_filter = JSON.parse(localStorage.getItem('storeDashboardFilter'))
                    this.filterData.created_templates = this.temp_dashb_filter.filterData.created_templates
                    this.filterData.created_tags = this.temp_dashb_filter.filterData.created_tags
                    localStorage.removeItem('storeDashboardFilter')
                }
                if(localStorage.getItem('getparticularTicket')){
                    let getDetails = JSON.parse(localStorage.getItem('getparticularTicket'))
                    this.list_id_index = getDetails.index
                    this.pagination.skip = getDetails.skip || 0
                    this.passed_key = getDetails.passed_key
                    this.pagination.limit = getDetails.limit
                    // localStorage.removeItem('getparticularTicket')
                } else {
                    this.pagination.skip = 0
                }
                this.getReviewTicketsCount()
                this.getAllTicketAPI()
            } catch(err){
                console.log(err);
            }
        },
        selectTickets(){
            this.hideOverall = false
        },
        selectViewDetail(ticket_obj){
            this.active_ticket = ticket_obj
        },
        showSelectedTicket(id){
            this.hideOverall = false
            this.$router.push({
                path: '/tickets/details/'+id
            })
        },
        async getTicketCountAPI(){
            let param = {
                is_maintenance: true
            }
            let res = await this.getTicketCount(String(this.$route.path).startsWith('/pm') ? param : {})
            this.closed = res.response.closed
            this.fixed = res.response.fixed
            this.open = res.response.open
            this.inprogress = res.response.inprogress
            this.reopened = res.response.reopened
            this.discard = res.response.discard
            this.total_tickets = res.response.total_tickets
            this.unassigned = res.response.unassigned
        },
        async getReviewTicketsCount(){
            try{
                let params = {
                    "limit": 10,
                    "skip": 0
                }
                let response = await this.ListTicketsToReview(params);
                this.review = response.response.total_no_of_tickets
            } catch(err) {
                console.log(err)
            }
        },
        async getAllTicketAPI(){
            if(localStorage.getItem('pagination_backup')){
                let redirection_pagination_backup = JSON.parse(localStorage.getItem('pagination_backup'))
                this.pagination = redirection_pagination_backup.pagination
            }
            if(this.$route.query.view_ticket == 'review'){
                try{
                    this.ajaxCallInProgress = true
                    let params = {
                        "limit": this.pagination.limit == "" || this.pagination.limit == 0 || this.pagination.limit < 0 ? 10 : this.pagination.limit,
                        "skip": this.pagination.skip || 0,
                        "sort_value": -1
                    }
                    let response = await this.ListTicketsToReview(params);
                    this.allTickets = response.response.all_tickets
                    this.allTickets.forEach((e) => {
                        if(e.part_review_status == 'Send For Approval' || e.part_review_status == 'Pending' || e.part_review_status == 'Sent For Approval'){
                            e.part_review_status = 'Review' 
                        }
                    })
                    this.list_id_index = 0
                    if(response.response.all_tickets.length > 0) this.showDetails = response.response.all_tickets[this.list_id_index]
                    this.pagination.total = response.response.total_no_of_tickets
                    this.ajaxCallInProgress = false
                } catch(err) {
                    this.ajaxCallInProgress = false
                    console.log(err)
                }
            } else {
                if(this.filterData.status.length > 1 && this.$route.query.hasOwnProperty('view_ticket') && this.$route.query.view_ticket != 'overall'){
                    this.dd_status = ''
                    this.selectView('overall', false)
                } else if(this.filterData.status.length == 1 && this.$route.query.hasOwnProperty('view_ticket') && !this.$route.query.view_ticket.startsWith(this.filterData.status[0].toLowerCase())) {
                    this.dd_status = ''
                    let temp_status = this.filterData.status[0].toLowerCase()
                    console.log(temp_status)
                    switch(temp_status){
                        case 'overall':
                            this.selectView(temp_status, false)
                            break;
                        case 'open':
                            this.selectView(temp_status, false)
                            break;
                        case 'inprogress':
                            this.selectView(temp_status, false)
                            break;
                        case 'fixed':
                            this.selectView(temp_status, false)
                            break;
                        case 'closed':
                            this.selectView(temp_status, false)
                            break;
                        case 'reopen':
                            this.selectView('reopened', false)
                            break;
                        case 'reopened':
                            this.selectView('reopened', false)
                            break;
                        case 'discard':
                            this.selectView(temp_status, false)
                            break;
                    };
                }
                this.filterData.status.forEach((element, index) => {
                    console.log(this.filterData.status[index])
                    if(this.filterData.status[index] == 'in progress'){
                        this.filterData.status[index] = 'inprogress'
                    }
                    if(this.filterData.status[index] == 'reopen' || this.filterData.status[index] == 'reopened'){
                        this.filterData.status[index] = 'reopened'
                    }
                });
                try {
                    this.ajaxCallInProgress = true
                    this.allTickets = []
                    let params = {
                        skip: this.pagination.skip || 0,
                        limit: this.pagination.limit,
                        search_key: this.search_key.trim(),
                        is_mobile:false,
                        sort_key: this.passed_key.key,
                        is_service_ticket:false,
                        filters:{
                            sort_value: this.passed_key.value,
                            assigned_to:{
                                select_all:false,
                                to:this.filterData.assign_to_whom,
                                value:this.filterData.assigned_to
                            },
                            branch:{
                                value:this.filterData.branch
                            },
                            company_name:{
                                value:this.filterData.company_name
                            },
                            date_range:{
                                created_date:this.filterData.created_date,
                                modification_date:this.filterData.last_modified_date,
                            },
                            department:{
                                value:this.filterData.department
                            },
                            priority:{
                                value:this.filterData.priority
                            },
                            product:{
                                select_all:false,
                                value:this.filterData.product
                            },
                            status:{
                                value:this.filterData.status,
                                select_all: false
                            },
                            ticket_number:{
                                select_all:false,
                                value:this.filterData.ticket_number
                            },
                            on_behalf_of:{
                                for:this.filterData.behalf_of_whom,
                                select_all:false,
                                value:this.filterData.behalf_selected
                            },
                            ticket_type:this.filterData.ticket_type,
                            tag :{
                                select_all: false,
                                value: this.filterData.created_tags,
                            },
                            template: {
                                select_all: false,
                                value: this.filterData.created_templates
                            },
                            approvers: {
                                select_all: false,
                                value: this.filterData.approvers
                            }
                        }
                    }
                    if(this.filterData.status.length == 0){
                        if(this.dd_status != ''){
                            params.filters.status.value = [this.dd_status]
                        }
                    }
                    if(params.filters.assigned_to.value.length){
                        params.filters.assigned_to.select_all = false
                    }else{
                        params.filters.assigned_to.select_all = true
                    }
                    if(params.filters.on_behalf_of.value.length){
                        params.filters.on_behalf_of.select_all = false
                    }else{
                        params.filters.on_behalf_of.select_all = true
                    }
                    if(params.filters.product.value.length){
                        params.filters.product.select_all = false
                    }else{
                        params.filters.product.select_all = true
                    }
                    if(params.filters.tag.value.length){
                        params.filters.tag.select_all = false
                    }else{
                        params.filters.tag.select_all = true
                    }
                    if(params.filters.ticket_number.value.length){
                        params.filters.ticket_number.select_all = false
                    }else{
                        params.filters.ticket_number.select_all = true
                    }
                    if(params.filters.status.value.length){
                        params.filters.status.select_all = false
                    }else{
                        params.filters.status.select_all = true
                    }
                    if(params.filters.template.value.length){
                        params.filters.template.select_all = false
                    }else{
                        params.filters.template.select_all = true
                    }
                    if(params.filters.approvers.value.length){
                        params.filters.approvers.select_all = false
                    }else{
                        params.filters.approvers.select_all = true
                    }
                    if(String(this.$route.path).startsWith('/pm')) {
                        params['is_maintenance'] = true;
                    }
                    let res = await this.getAllTickets(params)
                    this.allTickets = res.response.all_tickets
                    this.pagination.total = res.response.total_no_of_tickets
                    if(res.response.all_tickets.length != 0) {
                        if(localStorage.getItem('pagination_backup')){
                            let redirection_pagination_backup = JSON.parse(localStorage.getItem('pagination_backup'))
                            this.showDetails = redirection_pagination_backup.ticket_details
                            let tkt_index = res.response.all_tickets.map(x => x.ticket_id).indexOf(this.showDetails.ticket_id) != -1 ? res.response.all_tickets.map(x => x.ticket_id).indexOf(this.showDetails.ticket_id) : 0
                            this.list_id_index = tkt_index
                            localStorage.removeItem('pagination_backup')
                        }
                        this.showDetails = res.response.all_tickets[this.list_id_index]
                        this.is_ticket_not_found = false
                    }
                    else this.is_ticket_not_found = true
                    this.ajaxCallInProgress = false
                } catch (reason) {
                    console.log(reason)
                }
            }
        },
    },
    mounted(){
        if(localStorage.getItem('StoreFilterData')){
            let data = JSON.parse(localStorage.getItem('StoreFilterData'));
            this.filterData = {
                created_templates:  data.filterData.created_templates,
                created_tags:  data.filterData.created_tags,
                assigned_to: data.filterData.assigned_to,
                approvers:  data.filterData.approvers,
                branch: data.filterData.branch,
                company_name: data.filterData.company_name,
                created_date: data.filterData.created_date,
                department: data.filterData.department,
                last_modified_date:data.filterData.last_modified_date,
                priority: data.filterData.priority,
                product: data.filterData.product,
                status: data.filterData.status,
                ticket_number: data.filterData.ticket_number,
                template: data.filterData.template,
                assign_to_whom: data.filterData.assign_to_whom,
                behalf_of_whom: data.filterData.behalf_of_whom,
                behalf_selected: data.filterData.behalf_selected,
                ticket_type: data.filterData.ticket_type
            }
            this.showfilterData = {
                saveFilter:  data.showfilterData.saveFilter,
                created_templates:  data.showfilterData.created_templates,
                created_tags:  data.showfilterData.created_tags,
                assigned_to: data.showfilterData.assigned_to,
                approvers:  data.showfilterData.approvers,
                branch: data.showfilterData.branch,
                company_name: data.showfilterData.company_name,
                created_date: data.showfilterData.created_date,
                department: data.showfilterData.department,
                last_modified_date: data.showfilterData.last_modified_date,
                priority: data.showfilterData.priority,
                product: data.showfilterData.product,
                status: data.showfilterData.status,
                ticket_number: data.showfilterData.ticket_number,
                template: data.showfilterData.template,
                assign_to_whom: data.showfilterData.assign_to_whom,
                behalf_of_whom: data.showfilterData.behalf_of_whom,
                behalf_selected: data.showfilterData.behalf_selected,
                ticket_type: data.filterData.ticket_type
            }
        }
        EventBus.$on('viewReviewDetails', (data) => {
            this.general_details = data
        })
        if(localStorage.getItem('listData')){
            this.tabs = JSON.parse(localStorage.getItem('listData'))
        }
        EventBus.$on('UpdateTab', () => {
            this.selectView('overall',false)
        })
        EventBus.$on('RecallStatusTabs', () => {
            this.getTicketCountAPI()
        })
        this.getTicketCountAPI()
        EventBus.$on('updateActiveView',()=>{
            this.selectView('overall',false)
            this.getTicketCountAPI()
        })
        this.getReviewTicketsCount()
        if(this.$route.query.view_ticket){
            if(this.$route.query.view_ticket == 'opened'){
                this.selectView('open', false)
            } else {
                this.selectView(this.$route.query.view_ticket, false)
            }
        } else {
            this.selectView('overall',false)
        }
    },
    computed:{
        getSkipCount(){
            if(this.pagination.total == 0) {
                return 0
            } else {
                let skip_count = this.pagination.skip>this.pagination.total?this.pagination.total:this.pagination.skip+1;
                return skip_count;
            }
        },
    },
    destroyed(){
        EventBus.$off('updateActiveView');
        localStorage.removeItem('listData')
    }
}
</script>
<style scoped>
.selected-tag {
    background-color: #00448b !important; /* or any other styling you want */
    color: white !important; /* change text color to white for better contrast */
}
.tags-custom{
    height: 28px;
    border-radius: 5px;
    gap:.5rem;
    background-color: #f1f1f1;

}

.breadcrumbnewtheme{
    display: flex;
    align-items: center;
    gap: 1rem;
    color:#00448b;
}
.ticket_count{
    background-color: #7b7f97;
    border-radius: 20px;
    font-size: 10px;
    font-weight: 600 !important;
    color: #ffffff;
    margin-left: 4px;
    padding: 0px 6px;
}
.count-ticket{
    background-color: #1b57ad;
    border-radius: 20px;
    font-size: 10px;
    font-weight: 600 !important;
    color: #ffffff;
    margin-left: 4px;
    padding: 0px 6px;
}
.ticket_tab{
    background-color: #005dae;
}
.activeColor{
    background-color: #005dae;
    color: #ffffff;
}
.email-buttons{
    display: none;
}
@media screen and (max-width: 991px){
    .mob-list-scroll{
        min-width: 991px;
    }
}
.btn-success{
    background-color: #25bb83 !important;
}
.ticket-list-button{
    color: #363636;
    border-radius: 6px !important;
    box-shadow: none !important;
    font-weight: 600;
    background-color: #e4e4e4;
    width: 230px;
}
.view-box{
    border: 1px solid #a5a5a5;
    border-radius: 6px
}
.scm-filters {
    font-family: "Poppins", "Helvetica Neue", sans-serif !important;
    height: fit-content !important;
    overflow: auto !important;
    max-width: 768px;
    top: 100px;
    /* background: #e6ecff !important; */
}
.overflow-visible{
    overflow: scroll !important;
}

.scroll-new{
    overflow-y: scroll;
    width: 100%;
    height: max-content;
}

.scroll-new::-webkit-scrollbar {
    width: 2px;
    height: 1px !important;
}

.scroll-new::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: #00448b;
}
.col-small-left{
    width: 200px;
}
.col-small-right{
    position: relative;
    width: 700px;
}
.left-list{
    height: max-content !important;
}
@media (max-width: 900px) {
    .scroll-news{
        min-width: 900px;
        overflow-x: scroll !important;
    }
}
@media (max-width: 580px) {
    .vendor-list{
        height: 100% !important;
    }
    .left-list{
        height: 500px !important;
    }
}
.hor-line {
  width: 2px;
  height: 30px;
  background-color: #1b57ad;
}
.filter-box {
    width: 200px;
    height: 30px;
    padding: 2px 3.3px 1.5px 6.5px;
    border: solid 0.5px #363636;
    background-color: #fff;
}
.width-fit-content{
    width: fit-content
}
.fs-18{
    font-size: 18px;
}
.whitespace-nowrap{
    white-space: nowrap;
}
.dropbtn {
    background-color: #fff;
    cursor: pointer;
    margin-top: -5px;
    border-radius: 5px;
    line-height: 33px;
}
.res-width{
    min-width:60%
}
.ticket_list_number-selected{
    background-color: #00448b !important;
    color: #fff !important;
}
.ticket_list_number-selected .li_span{
    color: #fff !important
}
.ticket_list_number-selected i{
    color: #fff !important;
    border:1px solid #fff !important;
}
.ticket_list_number-selected i.no-border{
    border: none !important;
}
@media screen and (max-width:1347px) {
    .res-width{
        min-width:75%
    }
}
@media screen and (max-width:1011px) {
    .res-width{
        min-width:100%;
        flex-wrap: wrap
    }
}


.dropdown {
    position: relative;
    display: inline-block;
}
.dropdown-content {
    display: none;
    position: absolute;
    background-color: #fff;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    border-radius:5px;
    z-index: 1;
    right: 0px;
    top: 32px;
}
.dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}
.dropdown-content a:not([href]):not([tabindex]).tabbed {
    width: 100%;
    vertical-align: middle;
}
.dropdown-content a:not([href]):not([tabindex]).tabbed:hover {
    background-color: #eee;
}
.dropdown:hover .dropdown-content {
    display: block;
}
.height-fit-content{
    height:fit-content
}
.ticketlist-dropdown{
    color: #00448b !important;
    border-bottom: 1px solid #00448b;
    font-weight: 600;
    text-transform: capitalize !important;
}
.dropdown-item {
    line-height: 3.8rem !important;
    height: 3.8rem !important;
    text-decoration: none
}
.total-count{
    width: 50px;
}
.btn-secondary:hover{
    background-color: #00448b !important;
}
</style>
<!-- <template>
    <div>
        <div>
            <split-screen></split-screen>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    components: {
        'split-screen': DigiCollectLibrary.SplitScreen
    },
    methods: {
        
    },
    computed: {

    },
}
</script>

<style scoped>

</style> -->
